<div class="content-wrapper" id="bannerClose">
    <div class="page-header">
        <h4 class="page-titles">
            <span class="page-title-icons bg-gradient-primary text-white mr-2">
                <i class="mdi mdi-folder-multiple-outline"></i>
            </span> ข้อมูลโครงการ
        </h4>
        <nav aria-label="breadcrumb">
            <button class="btn btn-outline-primary btn-fw" style="float: right;"
                [routerLink]="[ '/committee/dashboard']">ย้อนกลับ</button>
        </nav>
    </div>

    <div class="row">
        <div class="col-12 grid-margin">

            <div class="card">
                <div class="row card-body">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-12">
                                <h4>
                                    <span>ชื่อโครงการ : </span> <span
                                        class="font-weight-light">{{detail_nproject.project_name}}</span>
                                </h4>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <table>
                                    <tr>
                                        <td class="text-left" style="vertical-align: top;">
                                            <p>ที่ตั้งโครงการ </p>
                                        </td>
                                        <td class="text-right" style="vertical-align: top;">
                                            <p><b>{{detail_nproject.project_site}}</b> </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" style="vertical-align: top;">
                                            <p>วันที่อนุมัติโครงการ </p>
                                        </td>
                                        <td class="text-right" style="vertical-align: top;">
                                            <p><b> {{detail_nproject.project_date}} </b> </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" style="vertical-align: top;">
                                            <p>ขนาดพื้นที่</p>
                                        </td>
                                        <td class="text-right" style="vertical-align: top;">
                                            <p><b> {{detail_nproject.project_area}} </b> </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" style="vertical-align: top;">
                                            <p>จำนวนแปลงที่ดิน </p>
                                        </td>
                                        <td class="text-right" style="vertical-align: top;">
                                            <p><b> {{detail_nproject.parcel_number}} แปลง</b></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" style="vertical-align: top;">
                                            <p>จำนวนเจ้าของที่ดิน</p>
                                        </td>
                                        <td class="text-right" style="vertical-align: top;">
                                            <p><b> {{detail_nproject.owner_number}} คน</b> </p>
                                        </td>
                                    </tr>
                                </table>
                            </div>



                            <div class="col-md-6">
                                <table class="">
                                    <tr>
                                        <td class="text-left" style="vertical-align: top;">
                                            <p>ประเภทการใช้ประโยชน์ที่ดิน </p>
                                        </td>
                                        <td class="text-right" style="vertical-align: top;">
                                            <p><b>{{detail_nproject.landuse}} </b> </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" style="vertical-align: top;">
                                            <p>ผังสี </p>
                                        </td>
                                        <td class="text-right" style="vertical-align: top;">
                                            <p><b> {{detail_nproject.cityplan}} </b> </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" style="vertical-align: top;">
                                            <p>ถนนตามผังเมือง </p>
                                        </td>
                                        <td class="text-right" style="vertical-align: top;">
                                            <p><b>สาย {{detail_nproject.road_cityplan}}</b> </p>
                                        </td>
                                    </tr>
                                </table>

                            </div>
                        </div>
                        <table class="table">
                            <tr>
                                <td class="text-left">
                                    <h3>งบประมาณทั้งโครงการ :</h3>
                                </td>
                                <td class="text-right">
                                    <h2><b class="budget-all">฿{{detail_nproject.budget |
                                            number:'1.2-2'}}</b> </h2>
                                </td>
                            </tr>
                        </table>
                    </div>



                    <div class="col-md-12">
                        <div class="card">
                            <hr>
                            <div class="row">
                                <div class="col-md-6">
                                    <h4 class="text-left"><b>แผนที่แสดงตำแหน่งโครงการ</b> <button
                                            class="btn btn-primary btn-xs" title="แก้ไขตำแหน่งโครงการ"
                                            style="float:right;margin-top: -10px;" (click)="editLocation()"><i
                                                class="mdi mdi-pencil"></i></button></h4>
                                    <div id="map2"> </div>
                                </div>
                                <div class="col-md-6">
                                    <h4 class="text-right"><b>แผนที่แสดงแผนผังโครงการ</b> </h4>
                                    <div id="map"> </div>
                                    <div class="col mt-2" align="center">
                                        <div class="col-12">
                                            <button class="btn btn-primary" *ngIf="!showmap" data-toggle="modal"
                                                data-target="#upload_landparcel" (click)="openForm('image_be')"><i
                                                    class="mdi mdi-upload">
                                                    อัปโหลดแผนผังโครงการ</i> </button>
                                        </div>
                                        <div class="modal fade" id="upload_landparcel" tabindex="-1" role="dialog"
                                            aria-hidden="true">
                                            <div class="modal-dialog" role="document">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="ModalLabel">
                                                            อัปโหลดแผนผังโครงการ</h5>
                                                        <button type="button" class="close" data-dismiss="modal"
                                                            aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <div class="row">
                                                            <div class="col-lg-12 mx-auto">
                                                                <select name="type" id="type" [(ngModel)]="type"
                                                                    class="form-control">
                                                                    <option value="image_be">ก่อนโครงการ
                                                                    </option>
                                                                    <option value="image_af">หลังโครงการ
                                                                    </option>
                                                                </select>
                                                                เลือกไฟล์ <b style="color: red;">
                                                                    *</b>
                                                                <input type="file" class="dropify" id="upload"
                                                                    (change)="onFileData($event)" accept="image/*" />
                                                                <img [src]="filedata" alt="filedata" *ngIf="filedata"
                                                                    style="width: 100%;height:100%">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button class="btn btn-gradient-primary"
                                                            (click)="submit()">อัปโหลด</button>
                                                        <button type="button" class="btn btn-light"
                                                            data-dismiss="modal">Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12">
                        <hr>
                        <div class="row">
                            <div class="col-lg-3 col-sm-12">
                                <ul class="nav nav-tabs nav-tabs-vertical" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home-2"
                                            role="tab" aria-controls="home" aria-selected="true"> เงินให้กู้ยืม
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile-2"
                                            role="tab" aria-controls="profile" aria-selected="false"> เงินอุดหนุน
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact-2"
                                            role="tab" aria-controls="contact" aria-selected="false"> เงินสนับสนุน
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact-3"
                                            role="tab" aria-controls="contact" aria-selected="false"> เงินทดรองจ่าย
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-9 col-sm-12">
                                <div class="tab-content tab-content-vertical">
                                    <div class="tab-pane fade show active" id="home-2" role="tabpanel"
                                        aria-labelledby="home-tab">
                                        <div class="text-center" *ngIf="detail_type_project2.length==0">
                                            <h3 style="color: #ebedf2;">ไม่พบข้อมูลที่เลือก</h3>
                                        </div>
                                        <div *ngFor="let item of detail_type_project2; let i=index">

                                            <h4><b>สัญญากู้ยืมเงิน
                                                </b> </h4>

                                            <div class="detail-content ">

                                                <table class="">
                                                    <thead>
                                                        <tr>
                                                            <th width="10%"></th>
                                                            <th width="20%"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                ผู้ขอรับการสนับสนุนด้านการเงิน :
                                                            </td>
                                                            <td class="text-right " style="vertical-align: top;">
                                                                {{item.fin_applicant}}
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" width="40%"
                                                                style="vertical-align: top;">
                                                                วัตุประสงค์การขอใช้เงินกองทุนฯ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.objective}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                ปีงบประมาณที่ได้รับเงินจากกองทุนฯ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.fund_year}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                วันที่อนุมัติเงิน :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_approve}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                สัญญา / ข้อตกลง ลงวันที่ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_agree}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                วันที่ครบกำหนดสัญญา :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_due}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left">
                                                                จำนวนเงินที่ได้รับ :
                                                            </td>
                                                            <td class="text-right ">
                                                                <h3>฿ {{item.amount_receive |
                                                                    number:'1.2-2'}} </h3>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left">
                                                                <p> <b style="color:#cc0000 ">จำนวนเงินคงค้าง
                                                                        :</b> </p>
                                                            </td>
                                                            <td class="text-right ">
                                                                <h2>
                                                                    <b style="color:#cc0000 ">฿
                                                                        {{item.amount_accrued |
                                                                        number:'1.2-2'}}</b>
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="profile-2" role="tabpanel"
                                        aria-labelledby="profile-tab">
                                        <div class="text-center" *ngIf="detail_type_project3.length==0">
                                            <h3 style="color: #ebedf2;">ไม่พบข้อมูลที่เลือก</h3>
                                        </div>
                                        <div *ngFor="let item of detail_type_project3; let i=index">
                                            <h4>
                                                <b>ข้อตกลงการรับเงินอุดหนุน </b>
                                            </h4>

                                            <div class="detail-content ">
                                                <table class="">
                                                    <thead>
                                                        <tr>
                                                            <th width="10%"></th>
                                                            <th width="20%"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                ผู้ขอรับการสนับสนุนด้านการเงิน :
                                                            </td>
                                                            <td class="text-right " style="vertical-align: top;">
                                                                {{item.fin_applicant}}
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" width="40%"
                                                                style="vertical-align: top;">
                                                                วัตุประสงค์การขอใช้เงินกองทุนฯ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.objective}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                ปีงบประมาณที่ได้รับเงินจากกองทุนฯ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.fund_year}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                วันที่อนุมัติเงิน :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_approve}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                สัญญา / ข้อตกลง ลงวันที่ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_agree}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                วันที่ครบกำหนดสัญญา :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_due}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left">
                                                                จำนวนเงินที่ได้รับ :
                                                            </td>
                                                            <td class="text-right ">
                                                                <h3>฿ {{item.amount_receive |
                                                                    number:'1.2-2'}} </h3>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left">
                                                                <p> <b style="color:#cc0000 ">จำนวนเงินคงค้าง
                                                                        :</b> </p>
                                                            </td>
                                                            <td class="text-right ">
                                                                <h2>
                                                                    <b style="color:#cc0000 ">฿
                                                                        {{item.amount_accrued |
                                                                        number:'1.2-2'}}</b>
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="contact-2" role="tabpanel"
                                        aria-labelledby="contact-tab">
                                        <div class="text-center" *ngIf="detail_type_project4.length==0">
                                            <h3 style="color: #ebedf2;">ไม่พบข้อมูลที่เลือก</h3>
                                        </div>
                                        <div *ngFor="let item of detail_type_project4; let i=index">

                                            <h4><b>ข้อตกลงการรับเงินสนับสนุน
                                                </b> </h4>

                                            <div class="detail-content ">
                                                <table class="">
                                                    <thead>
                                                        <tr>
                                                            <th width="10%"></th>
                                                            <th width="20%"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="text-left"> style="vertical-align: top;"
                                                                ผู้ขอรับการสนับสนุนด้านการเงิน :
                                                            </td>
                                                            <td class="text-right " style="vertical-align: top;">
                                                                {{item.fin_applicant}}
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" width="40%"
                                                                style="vertical-align: top;">
                                                                วัตุประสงค์การขอใช้เงินกองทุนฯ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.objective}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                ปีงบประมาณที่ได้รับเงินจากกองทุนฯ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.fund_year}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                วันที่อนุมัติเงิน :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_approve}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                สัญญา / ข้อตกลง ลงวันที่ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_agree}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                วันที่ครบกำหนดสัญญา :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_due}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left">
                                                                จำนวนเงินที่ได้รับ :
                                                            </td>
                                                            <td class="text-right ">
                                                                <h3>฿ {{item.amount_receive |
                                                                    number:'1.2-2'}} </h3>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left">
                                                                <p> <b style="color:#cc0000 ">จำนวนเงินคงค้าง
                                                                        :</b> </p>
                                                            </td>
                                                            <td class="text-right ">
                                                                <h2>
                                                                    <b style="color:#cc0000 ">฿
                                                                        {{item.amount_accrued |
                                                                        number:'1.2-2'}}</b>
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="contact-3" role="tabpanel"
                                        aria-labelledby="contact-tab">
                                        <div class="text-center" *ngIf="detail_type_project5.length==0">
                                            <h3 style="color: #ebedf2;">ไม่พบข้อมูลที่เลือก</h3>
                                        </div>
                                        <div *ngFor="let item of detail_type_project5; let i=index">

                                            <h4><b>ข้อตกลงการรับเงินทดรองจ่าย
                                                </b> </h4>
                                            <div class="detail-content ">
                                                <table class="">
                                                    <thead>
                                                        <tr>
                                                            <th width="10%"></th>
                                                            <th width="20%"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                ผู้ขอรับการสนับสนุนด้านการเงิน :
                                                            </td>
                                                            <td class="text-right " style="vertical-align: top;">
                                                                {{item.fin_applicant}}
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" width="40%"
                                                                style="vertical-align: top;">
                                                                วัตุประสงค์การขอใช้เงินกองทุนฯ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.objective}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                ปีงบประมาณที่ได้รับเงินจากกองทุนฯ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.fund_year}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                วันที่อนุมัติเงิน :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_approve}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                สัญญา / ข้อตกลง ลงวันที่ :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_agree}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left" style="vertical-align: top;">
                                                                วันที่ครบกำหนดสัญญา :
                                                            </td>
                                                            <td class="text-right" style="vertical-align: top;">
                                                                <h4> {{item.date_due}} </h4>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left">
                                                                จำนวนเงินที่ได้รับ :
                                                            </td>
                                                            <td class="text-right ">
                                                                <h3>฿ {{item.amount_receive |
                                                                    number:'1.2-2'}} </h3>
                                                            </td>
                                                        </tr>
                                                        <br>
                                                        <tr>
                                                            <td class="text-left">
                                                                <p> <b style="color:#cc0000 ">จำนวนเงินคงค้าง
                                                                        :</b> </p>
                                                            </td>
                                                            <td class="text-right ">
                                                                <h2>
                                                                    <b style="color:#cc0000 ">฿
                                                                        {{item.amount_accrued |
                                                                        number:'1.2-2'}}</b>
                                                                </h2>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>

                        <div>
                            <h4 class="text-left mt-2"><b>ภาพประกอบโครงการ</b> </h4>
                            <br>
                            <div class="col-12 text-center">
                                <ngx-gallery [options]="galleryOptions" [images]="galleryImages">
                                </ngx-gallery>
                                <hr>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>